import { ENV, isBackendProduction } from '../../config/app-env';

const FB_AUTH_URI =
  'https://www.facebook.com/v4.0/dialog/oauth?display=popup&auth_type=reauthenticate';
const GOOGLE_AUTH_URI = 'https://accounts.google.com/o/oauth2/v2/auth';

export const OAUTH_PROVIDER_CONFIG = {
  homeaway: {
    authorizeUri: 'https://ws.homeaway.com/oauth/authorize',
    clientId: ENV.HOMEAWAY_CLIENT_ID,
    // redirectUri: '/oauth-callback',
  },
  shopify: {
    authorizeUri: 'https://www.myshopify.com/admin/oauth/authorize',
    clientId: ENV.SHOPIFY_API_KEY,
    redirectUri: '/oauth-signup?provider=shopify',
    scope: ENV.SHOPIFY_SCOPE,
  },
  shopify_fivetran: {
    redirectUri: '/oauth-callback',
    largePopup: true,
  },
  bigcommerce: {
    authorizeUri: `https://login.bigcommerce.com/app/${ENV.BIGCOMMERCE_CLIENT_ID}/install`,
    clientId: ENV.BIGCOMMERCE_CLIENT_ID,
    redirectUri: '/oauth-callback',
  },
  woocommerce: {
    // placeholder URI as mywoocommerce.com is replaced with the client's store URL
    authorizeUri: `https://mywoocommerce.com/wc-auth/v1/authorize`,
    redirectUri: '/oauth-callback',
  },
  facebook: {
    authorizeUri: FB_AUTH_URI,
    clientId: ENV.FACEBOOK_APP_ID,
    redirectUri: '/oauth-callback',
    scope: 'email,ads_read',
  },
  instagram: {
    authorizeUri: FB_AUTH_URI,
    clientId: ENV.FACEBOOK_APP_ID,
    redirectUri: '/oauth-callback',
    scope: 'email,ads_read',
  },
  googleads: {
    authorizeUri: GOOGLE_AUTH_URI,
    prompt: 'consent',
    access_type: 'offline',
    clientId: ENV.GOOGLE_OAUTH_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/adwords',
    redirectUri: '/oauth-callback',
  },
  stripe: {
    authorizeUri:
      'https://connect.stripe.com/oauth/authorize?stripe_landing=login',
    clientId: ENV.STRIPE_CLIENT_ID,
    scope: 'read_only',
    redirectUri: '/oauth-callback',
  },
  authorizenet: {
    authorizeUri: isBackendProduction
      ? 'https://account.authorize.net/oauth/authorize'
      : 'https://sandbox.authorize.net/oauth/authorize',
    clientId: ENV.AUTHORIZE_NET_CLIENT_ID,
    scope: 'read',
    redirectUri: '/oauth-callback',
    sub: 'oauth',
  },
  paypal: {
    authorizeUri: isBackendProduction
      ? 'https://www.paypal.com/signin/authorize'
      : 'https://www.sandbox.paypal.com/signin/authorize',
    clientId: ENV.PAYPAL_CLIENT_ID,
    redirectUri: '/oauth-callback',
    scope: 'https://uri.paypal.com/services/reporting/search/read',
    sub: 'oauth',
  },
  braintree: {
    authorizeUri: ENV.BRAINTREE_AUTHORIZEURI,
    clientId: ENV.BRAINTREE_CLIENT_ID,
    redirectUri: '/oauth-callback',
    scope:
      'read_facilitated_transactions,transaction:search,subscription:search',
    sub: 'oauth',
  },
  square: {
    authorizeUri: isBackendProduction
      ? 'https://connect.squareup.com/oauth2/authorize'
      : 'https://connect.squareupsandbox.com/oauth2/authorize',
    clientId: ENV.SQUARE_APP_ID,
    redirectUri: '/oauth-callback',
    scope: 'MERCHANT_PROFILE_READ ORDERS_READ PAYMENTS_READ SETTLEMENTS_READ',
  },
  amazonads: {
    authorizeUri: 'https://www.amazon.com/ap/oa',
    clientId: ENV.AMAZON_CLIENT_ID,
    redirectUri: '/oauth-callback',
    scope: 'cpc_advertising:campaign_management',
  },
  amazon: {
    clientId: ENV.AMAZON_SPAPI_CLIENT_ID,
    appId: ENV.AMAZON_SPAPI_APP_ID,
    redirectUri: '/oauth-callback',
  },
  amzvendor: {
    clientId: ENV.AMAZON_SPAPI_CLIENT_ID,
    appId: ENV.AMAZON_SPAPI_APP_ID,
    redirectUri: '/oauth-callback',
  },
};
